/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { formatDate } from "date-fns";
import UserTherapyActivity from "../therapy/UserTherapyActivity";

interface TherapyActivitiesSectionProps {
  formattedDate: string;
  activityAdherence: any;
  filteredTherapies: any[];
  onClick?: (therapy: any) => any;
  title?: string;
  noDevicesPaired?: boolean;
}

/**
 * Component for displaying daily therapy activities
 */
const TherapyActivitiesSection: React.FC<TherapyActivitiesSectionProps> = ({
  formattedDate,
  activityAdherence,
  filteredTherapies,
  onClick,
  title = "TODAY'S THERAPIES",
  noDevicesPaired,
}) => {
  const getSectionTitle = () => {
    return title;
    // if (!activityAdherence) return title;

    // return activityAdherence?.date === formattedDate
    //   ? title
    //   : `THERAPIES FOR ${
    //       activityAdherence?.date
    //         ? formatDate(new Date(activityAdherence.date), "MMM dd yyyy")
    //         : ""
    //     }`;
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom:
          filteredTherapies.length > 1 || noDevicesPaired ? "180px" : "180px",
      }}
    >
      {" "}
      <div
        style={{
          marginTop: "-20px",
          position: "absolute",
          zIndex: 1,
          width: "100%",
        }}
      >
        <UserTherapyActivity
          userTherapies={[
            {
              title: getSectionTitle(),
              therapies: filteredTherapies || [],
            },
          ]}
          noDevicesPaired={noDevicesPaired}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default TherapyActivitiesSection;
